@if (panel(); as resolvedPanel) {
    <ng-container
        [ngComponentOutlet]="resolvedPanel.component"
        [ngComponentOutletInputs]="resolvedPanel.componentInputs ?? {}"
    />
} @else {
    <qpx-metadata
        icon="lucideFileText"
        label="Document"
        [value]="fileName()"
        presentation="detail"
    />
}
